Namespace 'Monitoring.Reports.Publications.Content'

class Monitoring.Reports.Publications.Content.DetailsView extends Backbone.View

  className: 'content-section content-details'
  template: JST['backbone/templates/monitoring/reports/publications/content/details']

  initialize: (@options = {}) ->
    # just set @options
    # @options.tags form is [code, name, count_label]

  type_by_tags: (content) ->
    content_tags = content.full_content.tags
    labels = _.map(content_tags, (tag_code) =>
      tag_data = _.find(@options.tags, (tag_data) -> tag_data[0] == tag_code)
      tag_data && tag_data[1]
    )
    _.compact(labels)

  render: ->
    content = @options.contents[0]
    ranking_helper = new Monitoring.Reports.Publications.RankingView(@options)
    text_sliced = ranking_helper.description_sliced(content)
    link = content.link
    short_link = @short_link(link)
    type = @type_by_tags(content)
    data = {
      content_id: content.content_id,
      date: content.date,
      short_link: short_link,
      link: link,
      type: type,
      content_text: text_sliced
    }
    # TODO tags, type
    @$el.html(@template(data))

  short_link: (full_link) ->
    full_link.replace(/.*facebook\.com/, 'fb.com')
